import React, { useEffect, useMemo } from 'react';
import { View, Text, StyleSheet, TextStyle } from 'react-native';
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withSpring,
} from 'react-native-reanimated';

interface AnimatedDigitProps {
  digit: number;
  height: number;
  textStyle?: TextStyle;
  animationDuration?: number;
}

const NUMBERS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

const AnimatedDigit: React.FC<AnimatedDigitProps> = ({
  digit,
  height,
  textStyle,
  animationDuration = 500,
}) => {
  const springConfig = useMemo(() => {
    const springMass = (animationDuration / 1000) * 1.2;
    return {
      mass: springMass,
      damping: 22,
      stiffness: 100,
    };
  }, [animationDuration]);

  const translateYSV = useSharedValue(0);

  useEffect(() => {
    translateYSV.value = withSpring(-height * digit, springConfig);
  }, [digit, height, springConfig]);

  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{ translateY: translateYSV.value }],
  }));

  return (
    <View style={[styles.digitContainer, { height }]}>
      <Animated.View style={animatedStyle}>
        {NUMBERS.map((num) => (
          <Text key={num} style={[styles.digit, textStyle, { includeFontPadding: false }]}>
            {num}
          </Text>
        ))}
      </Animated.View>
    </View>
  );
};

const styles = StyleSheet.create({
  digitContainer: {
    overflow: 'hidden',
  },
  digit: {
    textAlign: 'center',
  },
});

export default AnimatedDigit;
